import script from "./PatientList.vue?vue&type=script&lang=ts&setup=true"
export * from "./PatientList.vue?vue&type=script&lang=ts&setup=true"

import "./PatientList.vue?vue&type=style&index=0&id=6623b77e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6623b77e"]])

export default __exports__